module.exports = __webpack_public_path__ + "static/media/LivePanels_Web_defaultFrame@3x.563318a4.png";